import React from 'react';
import Navbar from '../../components/general/Navbar';
import About from '../../components/general/About';
import Footer from '../../components/general/Footer';

const AboutPage = () => {
  return (
    <>
      <Navbar />
      <About />
      <Footer />
    </>
  )
}

export default AboutPage;